module.exports = __webpack_public_path__ + "img/beauty-pass-white.2e00fce.svg";